import { EVehicleType, IVehicle, isManagedVehicleType } from '@okcargo-apps/shared-domain';
import { CreateVehicleAsCarrierCommand, UpdateVehicleAsCarrierCommand } from '@okcargo/command-processor';
import { VehicleForCarrierResponse } from '@okcargo/query-processor';

/**
 * Only TRACTOR, CANVAS and BOX vehicles are kept. Any other vehicle type is ignored.
 */
export function transformToIVehicle(response: VehicleForCarrierResponse): IVehicle | null {
  const type = response.type as unknown as EVehicleType;
  if (!isManagedVehicleType(type)) return null;

  return {
    id: response.id,
    plateNumber: response.plateNumber,
    type,
  };
}

export function transformToIVehicleList(responses: VehicleForCarrierResponse[]): IVehicle[] {
  return (responses ?? [])
    .map((response) => transformToIVehicle(response))
    .filter((vehicle): vehicle is IVehicle => vehicle !== null);
}

export function transformFromIVehicleToCreateCommand(vehicle: IVehicle): CreateVehicleAsCarrierCommand {
  return {
    id: vehicle.id || crypto.randomUUID(),
    plateNumber: vehicle.plateNumber,
    type: vehicle.type as unknown as CreateVehicleAsCarrierCommand['type'],
  };
}

export function transformFromIVehicleToUpdateCommand(vehicle: IVehicle): UpdateVehicleAsCarrierCommand {
  return {
    id: vehicle.id,
    plateNumber: vehicle.plateNumber,
    type: vehicle.type as unknown as UpdateVehicleAsCarrierCommand['type'],
  };
}
